
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collector/[collectorId]",
      function () {
        return require("private-next-pages/collector/[collectorId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collector/[collectorId]"])
      });
    }
  